<template>
    <div class="toast-container" :class="type">
        <div class="toast-content">
            <div class="toast-icon">
                <SuccessIcon v-if="type === 'success'" />
                <ErrorIcon v-else-if="type === 'error'" />
            </div>
            <div class="toast-msg">{{ msg }}</div>
        </div>
    </div>
</template>

<script>
import ErrorIcon from '../Icons/Toast/ErrorIcon.vue';
import SuccessIcon from '../Icons/Toast/SuccessIcon.vue';
export default {
    name:"ToastContent",
    components: {
        SuccessIcon,
        ErrorIcon
    },
    props: {
        type: {
            type: String,
            default: ""
        },
        msg: {
            type: String,
            default: ""
        }
    },
}
</script>

<style lang="scss">

</style>

<style scoped lang="scss">
.toast-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    gap: 16px;
    font-family: Gilroy;
    font-size: 16px;
    font-weight: 500;
    color: var(--text-color);
    max-width: 320px;
    position: relative;
    padding-left: 18px;
    z-index: 9999;
    pointer-events: auto;


    &.error {
    border-left: 6px solid #DF7070 !important;

        .toast-icon {
            color: #DF7070;
        }
    }

    &.success {
    border-left: 6px solid #70DF7B;
        .toast-icon {
            color: #70DF7B;
        }
    }
}

.toast-content {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    pointer-events: auto;
}

.toast-icon {
    flex-shrink: 0;
    pointer-events: auto;
}

.toast-msg {
    line-height: 1.2;
    pointer-events: auto;
}

.toast-close {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    color: #666;
    opacity: 0.7;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    pointer-events: auto;
    z-index: 10000;

    &:hover {
        opacity: 1;
    }
}

.fa-check-circle-o {
    color: var(--success-color);
    font-size: 40px;
}

.fa-exclamation-circle {
    color: red;
    font-size: 40px;
}
</style>
